import { render, staticRenderFns } from "./select-classification-step.vue?vue&type=template&id=703bf11a"
import script from "./select-classification-step.vue?vue&type=script&lang=js"
export * from "./select-classification-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports